module.exports = __webpack_public_path__ + "static/img/floor2-zdqysg.a2e245b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-zdqysg.png
// module id = CJdF
// module chunks = 1